import { render, staticRenderFns } from "./ActivePostDocs.vue?vue&type=template&id=669fae36&scoped=true&"
import script from "./ActivePostDocs.vue?vue&type=script&lang=js&"
export * from "./ActivePostDocs.vue?vue&type=script&lang=js&"
import style0 from "./ActivePostDocs.vue?vue&type=style&index=0&id=669fae36&prod&lang=css&"
import style1 from "./ActivePostDocs.vue?vue&type=style&index=1&id=669fae36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669fae36",
  null
  
)

export default component.exports